const params = new URLSearchParams(window.location.search);
const debug = params ? params.has("debug") : false;

const logger = {
  info: console.info,
  debug: console.debug,
  warn: console.warn,
  error: console.error,
};

export default logger;
